import { createSlice } from "@reduxjs/toolkit";

const facebookSlice = createSlice({
    name: "facebook",
    initialState: {
        facebooks: {
            listData: {
                current: null,
                previous: null,
            },
            isFetching: false,
            error: false,
        },
    },
    reducers: {
        getDataFacebookStart: (state) => {
            state.facebooks.isFetching = true;
        },
        getDataFacebookSuccess: (state, action) => {
            state.facebooks.isFetching = false;
            state.facebooks.listData = action.payload; // { current, previous }
            state.facebooks.error = false;
        },
        getDataFacebookFailed: (state) => {
            state.facebooks.isFetching = false;
            state.facebooks.error = true;
        },
    },
});

export const {
    getDataFacebookStart,
    getDataFacebookSuccess,
    getDataFacebookFailed,
} = facebookSlice.actions;

export default facebookSlice.reducer;

